module.exports = __webpack_public_path__ + "app/img/ea.034998ffa1.svg";